<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Home</ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home"/>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!--Welcome card-->
  <ion-card class="welcome-card">
    <ion-img class="img-title" alt="Aerial view of PSI" [src]="assets + '/psi_luftbild.jpg'"></ion-img>
    <ion-card-header>
      <ion-card-subtitle>PSI</ion-card-subtitle>
      <ion-card-title>Welcome to the Paul Scherrer Institute</ion-card-title>
    </ion-card-header>
    <ion-card-content>
        This is a web application to provide some useful information during your stay at PSI.
    </ion-card-content>
  </ion-card>
  <!--<ion-card color="corona">
    <ion-card-header>
      <ion-card-title>PSI Check-in</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      During the pandemic we'll help you avoid crowded places. Please use the <b>PSI Check-in </b>to let us know
      whether you are coming to the PSI.
      <hr>
      <ion-button color="dark" expand="block" routerLink="/psicheckin">
        <ion-icon slot="icon-only" name="chevron-forward"></ion-icon>
      </ion-button>
    </ion-card-content>
  </ion-card>-->

  <!--Link to PSI Facility News-->
  <ion-card>
    <ion-card-header>
      <ion-card-subtitle>QUICKLINK</ion-card-subtitle>
      <a class="newsletterlink" title="Link to the facility newsletter"
         href="https://www.psi.ch/science/facility-newsletter" target="_blank" rel="noopener noreferrer">
        <ion-card-title>PSI Facility News
          <ion-icon name="open-outline"></ion-icon>
        </ion-card-title>
      </a>
    </ion-card-header>
    <ion-card-content>
      PSI Facility News is an electronic newsletter with issues targeted at the users of the PSI facilities: the
      Swiss Light Source - SLS, the Swiss spallation neutron source - SINQ, the Swiss Muon Source - SμS, the
      Particle Physics facilities and the X-ray free electron laser facility - SwissFEL, with a total of
      approximately 5000 user visits each year. PSI Facility News will inform you quarterly about recent scientific
      highlights, upcoming calls for proposals, news and events.
    </ion-card-content>
  </ion-card>

  <!--Weather widget-->
  <ion-card class="weather-card">
    <a data-title="Weather of PSI" class="weatherwidget-io" href="https://forecast7.com/en/47d548d22/5232/"
       data-label_1="Paul Scherrer Institute" data-label_2="WEATHER" data-font="Fira Sans"
       data-icons="Climacons Animated" data-days="5" data-theme="weather_one">Paul Scherrer Institute WEATHER</a>
  </ion-card>
</ion-content>
